import ReportsManager from "@/components/admin/ReportsManager";

const Reports = () => {
  return (
    <div className="flex flex-1 flex-col min-h-0">
      <ReportsManager />
    </div>
  );
};

export default Reports;
